/**
 * Headings for the comment and repost modals.
 *
 * Both are keyed on whether the card shows its author rather than on whether a
 * name exists: authorless cards carry a blank post owner, and bookmark cards
 * under SOC-1990 hide a real one, so naming them in the heading is wrong either
 * way.
 */
const namesAuthor = (showAuthor: boolean, firstName: string): boolean =>
  showAuthor && Boolean(firstName);

export const getCommentHeading = (
  showAuthor: boolean,
  firstName: string,
): string =>
  namesAuthor(showAuthor, firstName)
    ? `Comment on ${firstName}'s post`
    : 'Comment on this post';

export const getRepostHeading = (
  showAuthor: boolean,
  firstName: string,
): string =>
  namesAuthor(showAuthor, firstName) ? `Repost ${firstName}'s post` : 'Repost';
